import { render, staticRenderFns } from "./PodcastLinks.vue?vue&type=template&id=e21fdc16"
import script from "./PodcastLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./PodcastLinks.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports